import Vue from "vue"
import VueRouter from "vue-router"
//import store from './../store/index';

Vue.use(VueRouter)

let router = new VueRouter({
    base: '/',
    //mode: "history",
    routes: [

        //schedule
        {
            path: "/",
            component: () => import("@/template/DefaultView"),
            children: [
                //inicio do agendamento
                {
                    path: "schedule/:officeId/:track?", //doctor_schedule
                    component: () => import("@/views/schedule/Index.vue"),
                    meta: {
                        //requiresAuth: true
                    }
                },
                //destino quando o evento for confirmado
                {
                    path: "schedule/confirmed/:officeId/:eventId/:doctorId", //doctor_schedule
                    component: () => import("@/views/schedule/Confirmed.vue"),
                    meta: {
                        //requiresAuth: true
                    }
                },
                //destino quando o evento for cancelado
                {
                    path: "schedule/canceled/:officeId/:eventId",
                    component: () => import("@/views/schedule/Canceled.vue"),
                    meta: {
                        //requiresAuth: true
                    }
                },
                //atualiza/cancela um agendamento
                //ESSA ROTA ERA UTILIZADA QUANDO UM LINK ERA ENVIADO PARA O PACIENTE
                //ATUALMENTE, A ATUALIZAÇÃO DO REGISTRO SE DÁ VIA BOTÕES DO WHATSAPP DE FORMA AUTOMÁTICA
                //PORTANTO, ESSA ROTA NÃO É MAIS UTILIZADA, MAS ESTÁ FUNCIONAL!!!
                // {
                //     path: "update/:eventId",
                //     component: () => import("@/views/update/Index.vue"),
                //     meta: {
                //         //requiresAuth: true
                //     }
                // },
                //fazer reagendamento              
                {
                    path: "reschedule/:eventId",
                    component: () => import("@/views/reschedule/Index.vue"),
                    meta: {
                        //requiresAuth: true
                    }
                },
                //evento não encontrado
                {
                    path: "schedule/404", //doctor_schedule
                    component: () => import("@/views/schedule/404.vue"),
                    meta: {
                        //requiresAuth: true
                    }
                },
                //informações do agendamento            
                {
                    path: "scheduled/:eventId",
                    component: () => import("@/views/scheduled/Index.vue"),
                    meta: {
                        //requiresAuth: true
                    }
                },
            ]
        },
    ]
})


// router.beforeEach((to, from, next) => {
//     if (to.matched.some(record => record.meta.requiresAuth)) {
//         // this route requires auth, check if logged in
//         // if not, redirect to login page.
//         if (!store.getters.user.token) {
//             next({ path: '/' }).catch(() => { })
//         } else {
//             next() // go to wherever I'm going
//         }
//     } else {
//         next() // does not require auth, make sure to always call next()!
//     }
// })

export default router